// Message
import ClassNames from 'classnames';
import Moment from 'moment';
import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';

import DomImage from './DomImage';
import DomText from './DomText';
import DomUserPicture from './DomUserPicture';
import { getTranslator } from '../locales';
import { deleteMessage } from '../redux/actions/threadsAction';

@connect((Store) => {
  const t = getTranslator();

  return {
    locale: Store.settings.locale,
    labels: {
      DELETE: t.t('Delete'),
      T_HOUR: t.t('hr'),
      T_JUST_NOW: t.t('just now'),
      T_MINUTE: t.t('min'),
    },
    luser: Store.luser
  }
})

export default class Message extends React.Component {
  handleDeleteMessage(messageId) {
    this.props.dispatch(deleteMessage(messageId));
  }

  render() {
    const isInsider = this.props.message.author.insider;
    const itemClass = ClassNames({
      'message': true,
      'own': this.props.isOwn,
      'insider': isInsider,
    });

    let content = '';
    let canBeDeleted = false;

    if (typeof this.props.typing === 'undefined' || this.props.typing === true) {
      content = (<div id="circleG">
        <div id="circleG_1" className="circleG"></div>
        <div id="circleG_2" className="circleG"></div>
        <div id="circleG_3" className="circleG"></div>
      </div>);
    }

    if (this.props.message.body) {
      canBeDeleted = true;
      content = <DomText text={this.props.message.body} />;
    }

    if (!content) {
      return (
        <span></span>
      );
    }

    const identityLine1 = isInsider ? this.props.message.author.name : '';
    const identityLine2 = isInsider ? this.props.message.author.current_title : this.props.message.author.name;
    const momentDuration = Moment.duration(Moment().diff(this.props.message.createdAt));
    const minElapsed = momentDuration.asMinutes();

    let durationString = '';

    if (minElapsed < 1) {
      durationString = this.props.labels.T_JUST_NOW;
    } else if (minElapsed < 60) {
      durationString = `${momentDuration.minutes()} ${this.props.labels.T_MINUTE}`;
    } else {
      durationString = `${_.round(momentDuration.asHours(), 0).toLocaleString(this.props.locale)} ${this.props.labels.T_HOUR}`;
    }

    const bubbleTextClassName = ClassNames({
      'paragraph': true,
      'brandedColor_bg brandedColor_border': (isInsider && !this.props.isOwn),
      'brandedColorLightBis_bg brandedColorLightBis_border': this.props.isOwn
    })

    return (
      <div className={itemClass}>
        <div className='picture'>
          <DomUserPicture user={this.props.message.author} isInsider={isInsider} size={isInsider ? 'm' : 's'} />
          <span className='date'>{durationString}</span>
        </div>
        <div className='bubble'>
          <strong className='identity'>{identityLine1} </strong>
          <span className='identity'>{identityLine2} </span>
          <div className={bubbleTextClassName}>{content}</div>
          {
            (() => {
              if (canBeDeleted && this.props.message.id && this.props.luser.insider) {
                return <span className='delete-link' onClick={this.handleDeleteMessage.bind(this, this.props.message.id)}>
                  <i className='pe-7s-close-circle'></i> {this.props.labels.DELETE}
                </span>
              }
            })()
          }
        </div>
        <div className='clear'></div>
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/Message.jsx